import { render, staticRenderFns } from "./GeneralDashboard.vue?vue&type=template&id=596e4383&"
import script from "./GeneralDashboard.vue?vue&type=script&lang=ts&"
export * from "./GeneralDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports